/* unplugin-vue-components disabled */import script from "./microCard.vue?vue&type=script&setup=true&lang=js"
export * from "./microCard.vue?vue&type=script&setup=true&lang=js"

import "./microCard.vue?vue&type=style&index=0&id=474bf254&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/高保障-门户上海杉达-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-474bf254"]])

export default __exports__